
const originalLog = console.log;

console.log = (...args) => {
  // Clear the console before any log statements
  console.clear();
  // Optionally, you can call the original log if you still want to see logs conditionally
  // originalLog(...args);
};
